<template>
  <b-sidebar
    id="blog-form-sidebar"
    :visible="isBlogFormSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @shown="getData(blogData)"
    @hidden="resetForm"
    @change="(val) => $emit('update:is-blog-form-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Blog Form</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <validation-observer v-slot="{ validate }" ref="formObserver">
        <b-form
          class="p-2"
          @submit.prevent="onSubmit(true)"
          @reset.prevent="resetForm"
        >
          <b-tabs v-model="tabIndex">
            <b-tab title="Content">
              <b-tabs content-class="mt-1" v-if="langs.length > 0">
                <b-tab
                  v-for="(lang, key) in langs"
                  :key="'tab-' + key"
                  :title="lang.name"
                >
                  <validation-provider
                    v-slot="{errors, validate}"
                    :name="'title_' + lang.code"
                    rules="required"
                  >
                    <b-form-group
                      label="Title"
                      :label-for="'title_' + lang.code"
                    >
                      <b-form-input
                        :id="'title_' + lang.code"
                        v-model="Data.title[lang.code]"
                        autofocus
                        :state="errors[0] ? false : null"
                        trim
                        :placeholder="'Title (' + lang.code + ')'"
                        @input="(value) => { validate(); changeTitle(lang.code, value); }"
                      />
                      <b-form-invalid-feedback>
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                    v-slot="{errors, validate}"
                    :name="'description_' + lang.code"
                    rules="min:0"
                  >
                    <b-form-group
                      label="Description"
                      :label-for="'description_' + lang.code"
                    >
                      <quill-editor
                        :options="editorOptions"
                        :id="'description_' + lang.code"
                        v-model="Data.description[lang.code]"
                        :state="errors[0] ? false : null"
                        @input="validate"
                      />
                      <b-form-invalid-feedback>
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                    v-slot="{errors, validate}"
                    :name="'slug' + lang.code"
                    rules="required"
                  >
                    <b-form-group
                      label="Slug"
                      :label-for="'slug' + lang.code"
                    >
                      <b-form-input
                        :id="'slug' + lang.code"
                        v-model="Data.slug[lang.code]"
                        autofocus
                        :state="errors[0] ? false : null"
                        trim
                        :placeholder="'Slug (' + lang.code + ')'"
                        @input="validate"
                      />
                      <b-form-invalid-feedback>
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-tab>
              </b-tabs>
              <hr />
              <validation-provider
                v-slot="{errors, validate}"
                name="category"
                rules="min:0"
              >
                <b-form-group label="Category" label-for="category_id">
                  <v-select
                    id="category_id"
                    v-model="Data.categories"
                    multiple
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="
                      catsData.map((g) => ({
                        title: g.title[currentLocale],
                        id: g.id,
                      }))
                    "
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              
              <validation-provider
                #default="validationContext"
                name="IsActive"
                rules="min:0"
              >
                <b-form-group label="Is Active" label-for="IsActive">
                  <b-form-checkbox
                    id="isactive"
                    checked="true"
                    class="custom-control-success"
                    v-model="Data.is_active"
                    switch
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <form-repeater-section
                v-if="isBlogFormSidebarActive && blogData"
                @refesh-list="refeshList"
                :blog-data="blogData"
                :blog-input-content-remove.sync="BlogInputContentRemove"
                :blog-input-content.sync="BlogInputContent"
              />
              <div class="border rounded p-2">
                <h4 class="mb-1">Cover Image</h4>
                <b-media
                  no-body
                  vertical-align="center"
                  class="flex-column flex-md-row"
                >
                  <b-media-aside>
                    <b-img
                      ref="refPreviewEl"
                      :src="Data.cover_image?Data.cover_image:require('@/assets/images/no-image.png')"
                      height="110"
                      width="170"
                      class="rounded mr-2 mb-1 mb-md-0"
                    />
                  </b-media-aside>
                  <b-media-body>
                    <small class="text-muted">
                      Required image resolution 800x400, image size 10mb.
                    </small>
                    <b-card-text class="my-50"> </b-card-text>
                    <div class="d-inline-block">
                      <b-form-file
                        ref="refInputEl"
                        v-model="Data.blogFile"
                        accept=".jpg, .png, .gif, .webp,"
                        placeholder="Choose file"
                        @input="inputImageRenderer"
                      />
                    </div>
                    <b-card-text class="my-50">
                      <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        v-if="Data.cover_image"
                        @click="revomeImage"
                        >Remove Image</b-button
                      >
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </div>
            </b-tab>
            <b-tab title="gallery" v-if="blogData">
              <upload-form v-if="tabIndex == 1" :blog-data.sync="blogData" />
            </b-tab>
            <b-tab title="SEO">
              <validation-provider
                #default="validationContext"
                name="meta_title"
                rules="min:0"
              >
                <b-form-group label="Meta Title" label-for="meta_title">
                  <b-form-input
                    id="meta_title"
                    v-model="Data.meta_title"
                    autofocus
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder="Meta Title"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <validation-provider
                #default="validationContext"
                name="meta_description"
                rules="min:0"
              >
                <b-form-group
                  label="Meta Description"
                  label-for="meta_description"
                >
                  <b-form-input
                    id="meta_description"
                    v-model="Data.meta_description"
                    autofocus
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder="Meta Description"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <validation-provider
                #default="validationContext"
                name="meta_keywords"
                rules="min:0"
              >
                <b-form-group
                  label="Meta Keywords"
                  label-for="meta_keywords"
                >
                  <b-form-input
                    id="meta_keywords"
                    v-model="Data.meta_keyword"
                    autofocus
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder="Meta Keywords"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-tab>
          </b-tabs>
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-success"
              class="mr-2"
              type="submit"
            >
              Save
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-danger"
              @click="hide"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import { $themeConfig } from '@themeConfig'
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback, BButton,
  BTabs, BTab, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BAvatar, BImg, BLink, BFormFile,
} from "bootstrap-vue";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import { required, alphaNum, email, password, confirmed } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import countries from "@/@fake-db/data/other/countries";
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";

import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import { slugify } from "@/@fake-db/utils";
import { quillEditor } from "vue-quill-editor";
import Quill from 'quill'
const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
Quill.register(sizeStyle, true)
import UploadForm from "./UploadForm.vue";

import languagesStoreModule from "@/views/languages/languagesStoreModule";
//import FormRepeaterBasic from './FormRepeaterBasic.vue'
import FormRepeaterContent from "./FormRepeaterContent.vue";
import FormRepeaterSection from "./FormRepeaterSection.vue";
import blogblockStoreModule from "../blogblockStoreModule";
import blogsectionStoreModule from "../blogsectionStoreModule";
import BlockRepeater from "./BlockRepeater.vue";
import sitesStoreModule from "../../sites/sitesStoreModule"

export default {
  components: {
    BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback, BButton,
    BTabs, BTab, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BAvatar, BImg, BLink, BFormFile, vSelect,
    quillEditor, ValidationProvider, ValidationObserver, FormRepeaterContent, UploadForm, FormRepeaterSection,
    BlockRepeater,
  },

  directives: {
    Ripple,
  },

  model: {
    prop: "isBlogFormSidebarActive",
    event: "update:is-blog-form-sidebar-active",
  },

  props: {
    isBlogFormSidebarActive: {
      type: Boolean,
      required: true,
    },
    blogData: {
      type: Object,
      required: false,
    },
    contentsData: {
      type: Array,
      required: false,
    },
    blog_id: {
      type: Number,
      required: false,
    },
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    editorOptions (){
      return $themeConfig.snowOption
    } 
  },

  setup(props, { emit }) {
    const {  appRef } = $themeConfig.app
    const toast = useToast();
    const catsData = ref([]);
    const tabIndex = ref(0);
    const featuredImage = ref({});
    const langs = ref([]);
    const formObserver = ref(null);
    const siteData = ref([])

    const LANGUAGES_STORE_MODULE_NAME = "app-languages";
    if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME))
      store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule);
    onUnmounted(() => {
      if (store.hasModule(LANGUAGES_STORE_MODULE_NAME))
        store.unregisterModule(LANGUAGES_STORE_MODULE_NAME);
    });

    const SECTION_STORE_MODULE_NAME = 'blog-section';
    if (!store.hasModule(SECTION_STORE_MODULE_NAME)) store.registerModule(SECTION_STORE_MODULE_NAME, blogsectionStoreModule)
    onUnmounted(() => {
        if (store.hasModule(SECTION_STORE_MODULE_NAME)) store.unregisterModule(SECTION_STORE_MODULE_NAME)
    });

    const BLOCK_STORE_MODULE_NAME = 'blog-block';
    if (!store.hasModule(BLOCK_STORE_MODULE_NAME)) store.registerModule(BLOCK_STORE_MODULE_NAME, blogblockStoreModule)
    onUnmounted(() => {
        if (store.hasModule(BLOCK_STORE_MODULE_NAME)) store.unregisterModule(BLOCK_STORE_MODULE_NAME)
    });

    const SITE_STORE_MODULE_NAME = 'app-sites';
    if (!store.hasModule(SITE_STORE_MODULE_NAME)) store.registerModule(SITE_STORE_MODULE_NAME, sitesStoreModule)
    onUnmounted(() => {
        if (store.hasModule(SITE_STORE_MODULE_NAME)) store.unregisterModule(SITE_STORE_MODULE_NAME)
    });

    const userStorage = JSON.parse(localStorage.getItem("userData"));
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    
    store.dispatch('app-blog/getCategoriesBySite')
    .then(response => {
      catsData.value = response.data.data
    })

    const blankData = {
      id: null,
      title: {},
      description: {},
      slug: {},
      categories: [],
      ordering_count: 0,
      is_active:true,
      meta_title: '',
      meta_description: '',
      meta_keyword: '',
      created_by: userStorage.id,
    };
    const Data = ref(JSON.parse(JSON.stringify(blankData)));
    const repeaters = {
      id: null,
      title: {},
      description: {},
      slug: {},
      ordering_count: 0,
    };
    const BlogInputContentRemove = ref([]);
    const BlogInputContent = ref([JSON.parse(JSON.stringify(repeaters))]);
    const resetData = () => {
      Data.value = JSON.parse(JSON.stringify(blankData));
    };

    const getData = async function (data) {
      tabIndex.value = 0;
      BlogInputContent.value = [];
      refPreviewEl.value.src = require("@/assets/images/no-image.png");

      Data.value.title = {}
      Data.value.description = {}
      Data.value.slug = {}
      Data.value.categories = []
      Data.value.ordering_count = 0
      Data.value.is_active = true
      Data.value.meta_title = ''
      Data.value.meta_description = ''
      Data.value.meta_keyword = ''
      Data.value.is_show = false

      if (data) {
        data.is_active = data.is_active? true: false
        data.is_show = data.is_show? true: false
        
        Data.value = {
          ...data,
          categories: Array.isArray(data.categories)?data.categories.map((g) => {
            return {
              title: g.title[this.currentLocale],
              id: g.category_id
            }
          })
          : [],
        }
        
        BlogInputContent.value = []
        if (data.contents && data.contents.length > 0) {
          BlogInputContent.value = data.contents
        }
      }
    };

    const getLangs = (fil) => {
      store.dispatch("app-languages/fetchData", fil).then((res) => {
        if (res.data.success) {
          langs.value = res.data.data;
        }
      });
    };

    let filter = {
      is_active:1,
    }
    
    getLangs(filter);

    const onSubmit = async () => {
      if (formObserver.value) {
        const isValid = await formObserver.value.validate();

        if (!isValid) {
          const errorMessages = Object.entries(formObserver.value.errors)
            .filter(([key, message]) => message.length)
            .map(([key, message]) => `${message}`)

          toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `Error`,
              icon: 'BellIcon',
              variant: 'danger',
              text: `${errorMessages.join(" , ")}`,
            },
          });

          return
        }
      }

      let formData = new FormData();

      Data.value.is_active = Data.value.is_active?1:0;
      Data.value.is_show = Data.value.is_show?1:0;

      if (BlogInputContentRemove.value.length > 0) {
        Data.value.content_remove = JSON.stringify(
          BlogInputContentRemove.value
        );
      }

      if (BlogInputContent.value.length > 0) {
        Data.value.content = JSON.stringify(BlogInputContent.value);
        for (const [key, value] of Object.entries(BlogInputContent.value)) {
          BlogInputContent.value[key].title_lang = JSON.stringify(value.title);
        }

        Data.value.content = JSON.stringify(BlogInputContent.value);
      }

      for (const [key, value] of Object.entries(Data.value)) {
        if (key == "title" || key == "description" || key == "slug" || key == "categories"){
          formData.append(key, JSON.stringify(value));
        }else{
          formData.append(key, value);
        }
      }

      // formData.append('categories', JSON.stringify(Data.value.categories));
      formData.append(
        "count_conent_remove",
        BlogInputContentRemove.value.length
      );
      formData.append('path', '/var/www/html/uploadfiles/uploads/'+appRef+'/blog/');
      formData.append('savepath', 'uploads/'+appRef+'/blog/');
      formData.append("count_conent", BlogInputContent.value.length);
      formData.append('data', JSON.stringify(Data.value))

      if (Data.value.id) {
        store
          .dispatch("app-blog/updateBlog", {
            formData: formData,
            id: Data.value.id
          })
          .then((res) => {
            if (res.data.success) {
              toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: `Success`,
                  icon: "BellIcon",
                  variant: "success",
                  text: `${res.data.message}`,
                },
              });
              emit("refetch-data");
              emit("update:is-blog-form-sidebar-active", false);
            } else {
              toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: `Error`,
                  icon: "BellIcon",
                  variant: "danger",
                  text: `${res.data.message}`,
                },
              });
            }
          });
      } else {
        store
          .dispatch("app-blog/addBlog", { formData: formData })
          .then((res) => {
              toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: `Success`,
                  icon: "BellIcon",
                  variant: "success",
                  text: `${res.data.message}`,
                },
              });

              emit("refetch-data");
              emit("update:is-blog-form-sidebar-active", false);
          })
          .catch((error) => {

            toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                    title: `Error`,
                    icon: "BellIcon",
                    variant: "danger",
                    text: error.response.data.message,
                },
            });
        })
      }
    };

    const changeTitle  = (langCode, value) => {
      Data.value.slug[langCode] =  slugify(value)
    }
    
    const refeshList = async () => {
      emit("refetch-data");
    };

    const resetForm = () => {
      Data.value = blankData
    }

    const {
      refFormObserver,
      getValidationState,
    } = formValidation(resetData);
    //upload
    const refInputEl = ref(null);
    const refPreviewEl = ref(null);
    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        refPreviewEl.value.src = base64;
      }
    );
    const revomeImage = () => {
      Data.value.featuredImage = require("@/assets/images/no-image.png");
      Data.value.cover_image = "";
    };

    onMounted(() => {
      store.dispatch("app-sites/fetchSites", {
          order_by: 'ordering_count ASC'
      }).then((res) => {
          const data = res.data.data
          siteData.value = data
      });
    })
            
    return {
      Data,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      getData,
      tabIndex,
      refInputEl,
      refPreviewEl,
      inputImageRenderer,
      revomeImage,
      changeTitle,
      BlogInputContent,
      BlogInputContentRemove,
      langs,
      refeshList,
      BlogInputContent,
      BlogInputContentRemove,
      catsData,
      formObserver,
      siteData,
    };
  },
  methods:{
    getOptionLabel(option) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = option.title;
        return tempDiv.textContent || tempDiv.innerText || "";
    },
  }
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/quill.scss";
</style>
